const API_DOMAIN = "https://exi-bo.hoyou.xyz/";
let EVENT_ID = null;

const winnerList = document.getElementById("winnerList");
const loadingScreen = document.getElementById("loadingScreen");

function sleep(ms) {
  return new Promise(r => setTimeout(r, ms));
}

function showLoading(show) {
  if (!loadingScreen) return;
  loadingScreen.style.display = show ? "flex" : "none";
}

// ✅ Check event status first (same as index)
async function checkEventStatus() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/event/list`);
    const data = await res.json();
    await sleep(50);

    if (data.message === "success" && Array.isArray(data.data) && data.data.length > 0) {
      const event = data.data[0];
      EVENT_ID = event.id;
      if (event.status === 2) {
        // ✅ Event is open → load winners
        await loadWinners();
      } else {
        // 🚫 Not active → go to event closed page
        window.location.href = "eventClosed.html";
      }
    } else {
      window.location.href = "eventClosed.html";
    }
  } catch (err) {
    console.error("Error checking event status:", err);
    window.location.href = "eventClosed.html";
  } finally {
    showLoading(false);
  }
}

// ✅ Load winners from API
async function loadWinners() {
  try {
    showLoading(true);
    const res = await fetch(`${API_DOMAIN}api/internal/battle/participants`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventId: EVENT_ID }),
    });

    const result = await res.json();
    await sleep(50);

    if (result.message === "success" && result.data?.winners?.length > 0) {
      const winners = result.data.winners;
      winnerList.innerHTML = winners
        .map(w => `<li class="player-item">${w.ticketId}</li>`)
        .join("");
    } else {
      winnerList.innerHTML = `<li class="player-item">No winners yet</li>`;
    }
  } catch (err) {
    console.error("Error fetching winners:", err);
    winnerList.innerHTML = `<li class="player-item">Error loading results</li>`;
  } finally {
    showLoading(false);
  }
}

// ✅ Init
document.addEventListener("DOMContentLoaded", async () => {
  showLoading(true);
  await sleep(50);
  await checkEventStatus();
});
